import {addIdToMap, getCustomId} from '../utils'
import {DATA_TYPES} from '../../../../constants/constants'
import {addNamespaceToStructure} from '../componentDeserializationStructure'
import type {DeserializeComponentParams} from '../types'

export const updateComponentControllersStructure = (deserializationParams: DeserializeComponentParams) => {
    const {compStructure, customId, mappers} = deserializationParams

    if (!compStructure.controllers) return

    const {oldToNewIdMap} = mappers ?? {oldToNewIdMap: {}}
    deserializationParams.customId = getCustomId(oldToNewIdMap, compStructure.controllers, customId)

    const controllersQuery = addNamespaceToStructure(
        deserializationParams,
        compStructure.controllers,
        DATA_TYPES.controllers,
        oldToNewIdMap
    )
    if (controllersQuery) {
        compStructure.controllersQuery = controllersQuery
        addIdToMap(compStructure.controllers, controllersQuery, oldToNewIdMap)
    }
}
